import * as React from "react";

import _ from "lodash";
import {t} from "i18next";
import {Dimmer, Loader} from "semantic-ui-react";

import Dialog from "../../../components/Dialogs/Dialog";
import Button from "../../../components/Button";

import {AMTBSelectContexts} from "./AMTBSelectContexts";
import {SummaryAMTBTransferDialog} from "./SummaryAMTBTransferDialog";
import {ModeltypeBasicDto, OptionDto, AssignmentTransferDto,} from "../../../services/Client";
import DataAdapterOptionsView from "../DataAdapterOptionsView";
import {renderErrorToast} from "../../../utils/FeedbackMessageUtils";
import {StepTab, StepHeader, SelectAction, AMTBTransferErrorTable} from "./AMTBTransferUtils";

interface IOptionAMTBTransferDialogProps {
    derivates: ModeltypeBasicDto[];
    items: DataAdapterOptionsView[];
    errorTransferResult?: {[key: number]: string};
    userLanguage: string;

    onClose: () => void;
    onRefresh: () => void;
    onSubmit: (value: AssignmentTransferDto) => void;
}

interface IOptionAMTBTransferDialogState {
    sourceMTB?: ModeltypeBasicDto;
    targetMTBs?: ModeltypeBasicDto[];
    transferItems: OptionDto[];
    activeTab: number;
    loaderActive: boolean;
}

export class OptionAMTBTransferDialog extends React.Component<IOptionAMTBTransferDialogProps, IOptionAMTBTransferDialogState> {

    constructor(props: IOptionAMTBTransferDialogProps) {
        super(props);

        this.state = {
            activeTab: StepTab.InitTab,
            transferItems: new Array(),
            loaderActive: false,
        };
    }

    componentDidUpdate(prevProps: Readonly<IOptionAMTBTransferDialogProps>): void {
        if (prevProps.derivates !== this.props.derivates
            || prevProps.items !== this.props.items) {

            this.setState({
                sourceMTB: undefined,
                targetMTBs: undefined,
                transferItems: new Array(),
                activeTab: StepTab.InitTab
            });
        }

        if (this.props.errorTransferResult && prevProps.errorTransferResult !== this.props.errorTransferResult) {
            this.setState({
                activeTab: StepTab.ResultTab,
                loaderActive: false
            });
        }
    }

    hasInvalidAssignment = (item: DataAdapterOptionsView) => {

        return false;
        // comment out the code as we need to support SV pdip
        // const selectedMTBIds = this.state.sourceMTB && this.state.targetMTBs ?
        //     new Set([this.state.sourceMTB.objectId, ...this.state.targetMTBs.map((tM) => tM.objectId)])
        //     : new Set();

        // return item.dto.modeltypes &&
        //     item.dto.modeltypes.find((amtb) => selectedMTBIds.has(amtb.modeltypeBasic.objectId) &&
        //         amtb.assignmentType === AssignedModeltypeBasicDtoAssignmentType.SV);
    }

    calculateTransferItems = () => {
        const transferItems = new Array();

        this.props.items.map((item) => {
            if (this.state.sourceMTB &&
                this.state.targetMTBs &&
                !this.hasInvalidAssignment(item)
            ) {
                transferItems.push(item.dto);
            }
        });

        this.setState({transferItems});
    }

    handleOptionSelectChange = (items: DataAdapterOptionsView[], actionType: SelectAction) => {
        let transferItems = _.cloneDeep(this.state.transferItems);

        switch (actionType) {
            case (SelectAction.SingleSelect):
                if (transferItems.some((e: OptionDto) => e.objectId === items[0].dto.objectId)) {
                    transferItems = transferItems.filter(function (val: OptionDto) {
                        return val.objectId !== items[0].dto.objectId;
                    });
                } else {
                    transferItems.push(items[0].dto);
                }
                break;
            case (SelectAction.SelectAll):
                items.forEach((val: DataAdapterOptionsView) => {
                    if (!(transferItems.some((e: OptionDto) => e.objectId === val.dto.objectId))) {
                        transferItems.push(val.dto);
                    }
                });
                break;
            case (SelectAction.DeselectAll):
                items.forEach((val: DataAdapterOptionsView) => {
                    transferItems = transferItems.filter(function (value: OptionDto) {
                        return value.objectId !== val.dto.objectId;
                    });
                });
                break;
            default:
                renderErrorToast({
                    message: "ERRORS:UNKNOWN_ACTION",
                    timestamp: Date.now()
                });
                break;
        }

        this.setState({
            transferItems
        });
    }

    confirmTransfer = () => {
        if (this.state.sourceMTB && this.state.targetMTBs) {
            this.setState({loaderActive: true});

            const reqParam: AssignmentTransferDto = {
                options: this.state.transferItems,
                sourceMTB: this.state.sourceMTB,
                targetMTBs: this.state.targetMTBs
            };

            this.props.onSubmit(reqParam);
        }
    }

    render() {
        const startedWfItems: DataAdapterOptionsView[] = [];
        const initialWfStepItems: DataAdapterOptionsView[] = [];
        const invalidItems: DataAdapterOptionsView[] = [];

        this.props.items.map((item: DataAdapterOptionsView) => {
            // check for invalid assignments => AssignedModeltypeBasicDtoAssignmentType.V
            // this type of assignments should not be maintained manually in ProMT
            if (this.hasInvalidAssignment(item)) {
                invalidItems.push(item);
            } else if (item.statusValueStates && item.statusValueState === item.statusValueStates[0].id) {
                initialWfStepItems.push(item);
            } else {
                startedWfItems.push(item);
            }
        });

        const dlgButton = this.state.activeTab === StepTab.ResultTab
            ? (
                <Button
                    key={"checkButton"}
                    icon={"check"}
                    onClick={this.props.onRefresh}
                    disabled={this.state.loaderActive}
                />
            )
            : (
                <Button
                    key={"cancelButton"}
                    icon={"ban"}
                    onClick={this.props.onClose}
                    disabled={this.state.loaderActive}
                />
            );

        return (
            <Dialog
                open={true}
                title={t("AMTB_TRANSFER:AMTB_TRANSFER_TITLE")}
                customStyleClassName={'multi-step-dialog'}
                actions={[dlgButton]}
            >

                <div style={{marginBottom: '30px'}}>
                    <StepHeader activeTab={this.state.activeTab} />
                </div>

                {/** First Step Start */}
                {this.state.activeTab === StepTab.InitTab &&
                    <AMTBSelectContexts
                        derivates={this.props.derivates}
                        sourceMTB={this.state.sourceMTB}
                        targetMTBs={this.state.targetMTBs}
                        userLanguage={this.props.userLanguage}
                        onChange={(sourceMTB, targetMTBs) => this.setState({sourceMTB, targetMTBs}, () => this.calculateTransferItems())}
                        nextAction={() => this.setState({activeTab: this.state.activeTab + 1})}
                    />
                }
                {/** First Step End */}

                {/** Second Step Start */}
                {this.state.activeTab === StepTab.SummaryTab && this.state.sourceMTB && this.state.targetMTBs &&
                    <SummaryAMTBTransferDialog
                        sourceMTB={this.state.sourceMTB}
                        targetMTBs={this.state.targetMTBs}
                        startedWfItems={startedWfItems}
                        invalidItems={invalidItems}
                        initialWfStepItems={initialWfStepItems}
                        transferItems={this.state.transferItems}
                        handleSelectChange={this.handleOptionSelectChange}
                        backAction={() => this.setState({activeTab: this.state.activeTab - 1})}
                        nextAction={() => this.setState({activeTab: this.state.activeTab + 1})}
                        userLanguage={this.props.userLanguage}
                    />
                }
                {/** Second Step End */}

                {/** Third Step Start */}
                {this.state.activeTab === StepTab.ConfirmTab && this.state.sourceMTB && this.state.targetMTBs && this.state.transferItems.length > 0 &&
                    <>
                        {this.state.loaderActive &&
                            <Dimmer active={this.state.loaderActive}>
                                <Loader>{t("AMTB_TRANSFER:LOADING_TRANSFER")}</Loader>
                            </Dimmer>
                        }
                        <div style={{marginBottom: '20px'}}>
                            <p>{t("AMTB_TRANSFER:SUBMIT_TOTAL_TXT") + ' '} <b>{this.state.transferItems.length}</b></p>
                        </div>
                        <div style={{marginTop: '30px'}}>
                            <Button
                                icon={'arrow left'}
                                onClick={() => this.setState({activeTab: this.state.activeTab - 1})}
                            />
                            <Button
                                icon={'arrow right'}
                                style={{float: 'right'}}
                                onClick={this.confirmTransfer}
                            />
                        </div>
                    </>
                }
                {/** Third Step End */}

                {/** Fourth Step Start */}
                <>
                    {this.state.activeTab === StepTab.ResultTab && this.props.errorTransferResult &&
                        <div>
                            <p>
                                <b>{this.state.transferItems.length - Object.keys(this.props.errorTransferResult).length}</b>
                                {' ' + t("AMTB_TRANSFER:RESULT_SUCCESS")}
                            </p>
                            {
                                Object.keys(this.props.errorTransferResult).length > 0 &&
                                <AMTBTransferErrorTable
                                    result={this.props.errorTransferResult}
                                    items={this.state.transferItems}
                                />
                            }
                        </div>

                    }
                </>
                {/** Fourth Step End */}
            </Dialog >
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/OptionsView/amtbTransfer/OptionAMTBTransferDialog.tsx